import { defineStore } from 'pinia';

import { ILang, IMarket } from '@/types/region';
import { DEFAULT_LANGUAGE, LOCAL_STORAGE_APP_ID, APP_NAME, DEFAULT_MARKET } from '@/constants';
interface AppState {
	isShowUserMenu: boolean;
	isShowHeaderMenu: boolean;
	market: IMarket;
	language: ILang;
	detectedLanguage: string;
	authRedirect: string;
	timezoneString: string;
	myAccountUrl: string;
	title: string;
	isAuthorized: boolean;
}

const defaultAppState: AppState = {
	isShowUserMenu: false,
	isShowHeaderMenu: false,
	market: DEFAULT_MARKET,
	language: DEFAULT_LANGUAGE,
	detectedLanguage: '',
	authRedirect: '',
	timezoneString: '',
	myAccountUrl: '',
	title: APP_NAME,
	isAuthorized: false,
};

export const useAppStore = defineStore({
	id: 'appStore',
	state: (): AppState => {
		try {
			const ls = localStorage.getItem(LOCAL_STORAGE_APP_ID) || '{}';
			const storageAppData = JSON.parse(ls);
			const _state = useMergeWith(defaultAppState, storageAppData, (objValue, srcValue) => {
				if (!srcValue) return objValue;
				return srcValue;
			});
			return _state;
		} catch (_) {
			return defaultAppState;
		}
	},
	actions: {
		closeAllMenu() {
			this.isShowUserMenu = false;
			this.isShowHeaderMenu = false;
		},
		updateUserMenuState(state: boolean) {
			this.closeAllMenu();
			this.isShowUserMenu = state;
		},
		updateHeaderMenuState(state: boolean) {
			this.closeAllMenu();
			this.isShowHeaderMenu = state;
		},
		updateMarket(value: IMarket) {
			this.market = value;
			this.persistenceState();
		},
		updateLanguage(value: ILang) {
			this.language = value;
			this.persistenceState();
		},
		setDetectedLanguage(value: string) {
			this.detectedLanguage = value;
			this.persistenceState();
		},
		updateAuthRedirect(routeName: string) {
			this.authRedirect = routeName;
			this.persistenceState();
		},
		updateTimezoneString(timezoneString: string) {
			this.timezoneString = timezoneString;
			this.persistenceState();
		},
		updateMyAccountUrl(url: string) {
			this.myAccountUrl = url;
		},
		updateIsAuthorized(value: boolean) {
			this.isAuthorized = value;
		},
		persistenceState() {
			const _state = {
				...this.$state,
				...{ isShowUserMenu: undefined, isShowHeaderMenu: undefined, myAccountUrl: undefined },
			};
			localStorage.setItem(LOCAL_STORAGE_APP_ID, JSON.stringify(_state));
		},
	},
	getters: {
		getUserMenuState: (state) => state.isShowUserMenu,
		getHeaderMenuState: (state) => state.isShowHeaderMenu,
		getMarket: (state) => state.market,
		getLanguage: (state) => state.language,
		getDetectedLanguage: (state) => state.detectedLanguage,
		getAuthRedirect: (state) => state.authRedirect,
		getTimezoneString: (state) => state.timezoneString,
		getMyAccountUrl: (state) => state.myAccountUrl,
		getIsAuthorized: (state) => state.isAuthorized,
	},
});
